import axios from "../../api/httpClient";
import { getApiHeaders } from "../../api/apiHeaders";
//import { I18n } from "react-redux-i18n";
import {
    STOCK_ORDER_LIST_ATTEMPT,
    STOCK_ORDER_LIST_SUCCESS,
    STOCK_ORDER_LIST_FAILED,
    ////////////////////
    STOCK_ORDER_NEW_SUCCESS,
    STOCK_ORDER_NEW_FAILED,
    ///////////////////
    STOCK_ORDER_REMOVE_SUCCESS,
    STOCK_ORDER_REMOVE_FAILED,
    ///////////
    STOCK_ORDER_SET_ITEM
} from "../types/stockOrderTypes";
import { config } from "../../config";
const url_api = config.api.web;

export function loading() {
    return {
        type: STOCK_ORDER_LIST_ATTEMPT
    };
}

export function success(data) {
    return {
        type: STOCK_ORDER_LIST_SUCCESS,
        data: data
    };
}

export function failed(error) {
    return {
        type: STOCK_ORDER_LIST_FAILED,
        error: error
    };
}

///////////////////////////////////////////
/*
export function loadingMore() {
    return {
        type: AD_MORELIST_ATTEMPT
    };
}

export function successMore(data) {
    return {
        type: AD_MORELIST_SUCCESS,
        data: data
    };
}

export function failedMore(error) {
    return {
        type: AD_MORELIST_FAILED,
        error: error
    };
}
*/
export function successNew(item) {
    return {
        type: STOCK_ORDER_NEW_SUCCESS,
        item: item
    };
}



export function failedNew(error) {
    return {
        type: STOCK_ORDER_NEW_FAILED,
        error: error
    };
}
//////////////////////////
export function successRemove(item) {
    return {
        type: STOCK_ORDER_REMOVE_SUCCESS,
        item: item
    };
}

export function failedRemove(error) {
    return {
        type: STOCK_ORDER_REMOVE_FAILED,
        error: error
    };
}
////////////////////
export function set(item) {
    return {
        type: STOCK_ORDER_SET_ITEM,
        item: item
    };
}

////////////////////////
export const setItem = (data: Object) => async dispatch => {
    dispatch(set(data.item));
}

export const loadList = (data: Object) => async dispatch => {
    dispatch(loading());
    await axios
        .get(url_api + "stock_order/", {
            params: {
                id: data.user_id,
                //token: data.token,
                //lang: I18n.t("locale")
            },
            headers: getApiHeaders(),
        })
        .then(function (response) {
            //console.log(response);
            if (response.status < 300) {
                if (response.data.status === 'Success')
                    dispatch(success(response.data.body));
                else dispatch(failed(response.data.body));
            } else {
                dispatch(failed("try_later"));
            }
        })
        .catch(function (error) {
            console.log(error);
            if (error.Error) {
                dispatch(failed("try_later"));
            } else {
                dispatch(failed("try_later"));
            }
            return;
        });
};

export const newItem = (data: Object) => async (dispatch) => {
    //  console.log(data.params);
    await axios({
        method: "post",
        url: url_api + "stock_order/",
        data: data.params,
        headers: getApiHeaders(),
    }).then(function (response) {
        //  console.log(response);
        if (response.status < 300) {
            if (response.data.status === 'Success')
                dispatch(successNew(response.data.body));
            else dispatch(failedNew(response.data.body));
        } else {
            dispatch(failedNew("try_later"));
        }
    })
        .catch(function (error) {
            //console.log(error);
            if (error.Error) {
                dispatch(failedNew("try_later"));
            } else {
                dispatch(failedNew("try_later"));
            }
            return;
        });
};

export const removeItem = (data: Object) => async (dispatch) => {
    await axios({
        method: "delete",
        url: url_api + "stock_order/item",
        params: data.params,
        headers: getApiHeaders(),
        withCredentials: true,
    })
        .then(function (response) {
            if (response.status < 300 && response.data.status === 'Success') {
                dispatch(successRemove(response.data.body));
            } else {
                dispatch(failedRemove(response.data?.body || "try_later"));
            }
        })
        .catch(function (error) {
            dispatch(failedRemove(error.response?.data?.body || "try_later"));
        });
};

export const removeSymbol = (data: Object) => async (dispatch) => {
    await axios({
        method: "delete",
        url: url_api + "stock_order/symbol",
        params: data.params,
        headers: getApiHeaders(),
        withCredentials: true,
    })
        .then(function (response) {
            if (response.status < 300 && response.data.status === 'Success') {
                dispatch(successRemove(response.data.body));
            } else {
                dispatch(failedRemove(response.data?.body || "try_later"));
            }
        })
        .catch(function (error) {
            dispatch(failedRemove(error.response?.data?.body || "try_later"));
        });
};

export const updateItem = (data: Object) => async (dispatch) => {
    await axios({
        method: "put",
        url: url_api + "stock_order/item",
        data: data.params,
        headers: getApiHeaders(),
    })
        .then(function (response) {
            //  console.log(response);
            if (response.status < 300) {
                if (response.data.status === 'Success')
                    dispatch(successRemove(response.data.body));
                else dispatch(failedRemove(response.data.body));
            } else {
                dispatch(failedRemove("try_later"));
            }
        })
        .catch(function (error) {
            //console.log(error);
            if (error.Error) {
                dispatch(failedRemove("try_later"));
            } else {
                dispatch(failedRemove("try_later"));
            }
            return;
        });
};

export const updateSymbol = (data: Object) => async (dispatch) => {
    await axios({
        method: "put",
        url: url_api + "stock_order/symbol",
        data: data.params,
        headers: getApiHeaders(),
    })
        .then(function (response) {
            //  console.log(response);
            if (response.status < 300) {
                if (response.data.status === 'Success')
                    dispatch(successRemove(response.data.body));
                else dispatch(failedRemove(response.data.body));
            } else {
                dispatch(failedRemove("try_later"));
            }
        })
        .catch(function (error) {
            //console.log(error);
            if (error.Error) {
                dispatch(failedRemove("try_later"));
            } else {
                dispatch(failedRemove("try_later"));
            }
            return;
        });
};

export const updateReference = (data: Object) => async (dispatch) => {
    await axios({
        method: "put",
        url: url_api + "stock_order/reference",
        data: data.params,
        headers: getApiHeaders(),
    })
        .then(function (response) {
            //  console.log(response);
            if (response.status < 300) {
                if (response.data.status === 'Success')
                    dispatch(successNew(response.data.body));
                else dispatch(failedNew(response.data.body));
            } else {
                dispatch(failedNew("try_later"));
            }
        })
        .catch(function (error) {
            //console.log(error);
            if (error.Error) {
                dispatch(failedNew("try_later"));
            } else {
                dispatch(failedNew("try_later"));
            }
            return;
        });
};